// src/redux/rentCorpApi.js
import {apiSlice} from "./apiSlice";

export const adminRentCorpApi = apiSlice.injectEndpoints({
    endpoints: (build) => ({
        // 렌트카 법인 상세 조회
        getRentCorpDetailAdmin: build.query({
            query: (rentCorpId) => ({
                url: `/api/admin/rent_corp/v1/${rentCorpId}`,
                method: "get",
                headers: { token: true },
            }),
        }),

        // 활동 지역 상세조회
        getRentCorpAreaDetailAdmin: build.query({
            query: (rentCorpId) => ({
                url: `/api/admin/rent_corp/v1/${rentCorpId}/area`,
                method: "get",
                headers: { token: true },
            }),
        }),

        // 활동 지역 설정
        updateRentCorpAreaAdmin: build.mutation({
            query: ({ rentCorpId, body }) => ({
                url: `/api/admin/rent_corp/v1/${rentCorpId}/area`,
                method: "put",
                headers: { token: true },
                data: body,
            }),
        }),

        // 활동 지역 리스트 조회
        getRentCorpAreaAdmin: build.query({
            query: () => ({
                url: "/api/admin/rent_corp/v1/area",
                method: "get",
                headers: { token: true },
            }),
        }),

        // 렌트카 업체 리스트 조회
        getRentCorpListAdmin: build.mutation({
            query: ({ query, primary_yn, address_code_1_id, address_code_2_id }) => ({
                url: "/api/admin/rent_corp/v1",
                method: "get",
                headers: { token: true },
                params: {
                    query,
                    primary_yn,
                    address_code_1_id,
                    address_code_2_id,
                },
            }),
        }),

        // 업체 수정
        updateRentCorpAdmin: build.mutation({
            query: ({ rentCorpId, body }) => ({
                url: `/api/admin/rent_corp/v1/${rentCorpId}`,
                method: "put",
                headers: { token: true },
                data: body,
            }),
        }),

        // 메인 대표 회사 설정
        setRentCorpPrimaryAdmin: build.mutation({
            query: (rentCorpId) => ({
                url: `/api/admin/rent_corp/v1/${rentCorpId}/primary`,
                method: "put",
                headers: { token: true },
            }),
        }),
    }),
});

export const {
    useGetRentCorpDetailAdminQuery,
    useGetRentCorpAreaDetailAdminQuery,
    useUpdateRentCorpAreaAdminMutation,
    useGetRentCorpAreaAdminQuery,
    useGetRentCorpListAdminMutation,
    useUpdateRentCorpAdminMutation,
    useSetRentCorpPrimaryAdminMutation,
} = adminRentCorpApi;
